var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "100",
      "fill": "#2196F3"
    }
  }), _c('path', {
    attrs: {
      "d": "M200 100c0 55.2-44.8 100-100 100V0c36.4 0 68.4 19.5 85.9 48.6C194.3 62.8 200 80.8 200 100z",
      "fill": "#1D7FCE"
    }
  }), _c('path', {
    attrs: {
      "d": "M40 60c0-5 3.8-7.6 9.2-6.2L97 68v98L46.8 152C42.2 150.6 40 147.6 40 143V60z",
      "fill": "#2A3B4F"
    }
  }), _c('path', {
    attrs: {
      "d": "M160 60c0-5-3.8-7.6-9.2-6.2L103 68v98l50.2-14c4.6-1.4 6.8-4.4 6.8-9V60z",
      "fill": "#324B5E"
    }
  }), _c('path', {
    attrs: {
      "d": "M48 66c0-3.6 2.8-5.6 7-4.6L97 74v86L53.6 147c-3.2-1-5.6-3.2-5.6-6.2V66z",
      "fill": "#FFF6D6"
    }
  }), _c('path', {
    attrs: {
      "d": "M152 66c0-3.6-2.8-5.6-7-4.6L103 74v86l43.4-13c3.2-1 5.6-3.2 5.6-6.2V66z",
      "fill": "#FFC61B"
    }
  }), _c('path', {
    attrs: {
      "d": "M103 74l42-12.4V147L103 160V74z",
      "fill": "#F4B400",
      "opacity": "0.35"
    }
  }), _c('path', {
    attrs: {
      "d": "M100 70v96",
      "stroke": "#1A2838",
      "stroke-width": "5",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M58 90h32M56 104h30M58 118h26",
      "stroke": "#2A3B4F",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "opacity": "0.22"
    }
  }), _c('path', {
    attrs: {
      "d": "M110 90h32M112 104h28M114 118h24",
      "stroke": "#2A3B4F",
      "stroke-width": "4",
      "stroke-linecap": "round",
      "opacity": "0.18"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }